import { LevelPool } from '@trustpad/launchpad';
import {
  StakingState,
  UserState,
} from '@trustpad/launchpad/dist/staking/hooks/useStakingV2';
import * as React from 'react';

export function StakingConfigOverview({
  state,
  stakingConfig,
}: {
  state: StakingState;
  stakingConfig: LevelPool;
}) {
  return (
    <table className="text-gray-100 w-full table-fixed">
      <tbody>
        <tr>
          <td className="font-medium w-48">Lock period</td>
          <td>{stakingConfig.lockPeriod}</td>
        </tr>
        <tr>
          <td className="font-medium">Rewards</td>
          {stakingConfig.apy > 0 ? (
            <td>
              Claimable{' '}
              {stakingConfig.maturityPeriod
                ? `${stakingConfig.maturityPeriod}`
                : 'on maturity'}
            </td>
          ) : (
            <td>No</td>
          )}
        </tr>
        {state.alwaysLockOnRegister || state.alwaysLockOnRegister ? (
          <tr>
            <td className="font-medium">
              Extends lock <br /> on sale registration
            </td>
            <td>
              {state.alwaysLockOnRegister ? (
                <>
                  Yes, for <b>{stakingConfig.lockPeriod}</b>
                </>
              ) : (
                <>No (only once unlocked)</>
              )}
            </td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );
}
